import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { Report } from '../types';
import { apiFetch } from '@/core';
import env from '@/env';

type Body = {
  note?: string;
  leaderNote?: string;
};

export const createAuditorVisitReport = async ({
  visitId,
  data,
}: {
  visitId: string;
  data: Body;
}): Promise<Report> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/${visitId}/reports`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as Report;
  return response;
};
